import ICoursesPage from "../models/view/coursesPage/ICoursesPage";
import Course from "../client/models/myLibrary/Course";
import {miscImages} from "../config/config";
import ICourseCard from "../models/view/coursesPage/ICourseCard";
import NamedCourseList from "../client/models/myLibrary/NamedCourseList";

export function createCoursesPageViewModel(
  courses: NamedCourseList[],
  hasCoursesModalBeenDisplayedForTheFirstTime: boolean,
  tab?: string,
): ICoursesPage {
  const tabs = courses.length ? courses.map(c => c.name) : [];
  const defaultTab = tabs.length ? tabs[0] : undefined;
  const selectedTab = tab && tabs.includes(tab) ? tab : defaultTab;
  const selectedCourseList = courses.find(c => c.name === selectedTab);
  const courseCards = selectedCourseList ? createCourseCards(selectedCourseList.courses) : [];
  const coursesPage: ICoursesPage = {
    categorizedCourses: courses,
    tabs,
    selectedTab,
    courseCards,
    isLoading: false,
    isInfoModalVisible: !hasCoursesModalBeenDisplayedForTheFirstTime,
  };
  return coursesPage;
}

export function createInitialCoursesPageViewModel(): ICoursesPage {
  const coursesPage: ICoursesPage = {
    categorizedCourses: [],
    tabs: [],
    selectedTab: undefined,
    courseCards: [],
    isLoading: true,
    isInfoModalVisible: false,
  };
  return coursesPage;
}

function createCourseCards(courses: Course[]): ICourseCard[] {
  return courses.map(c => createCourseCard(c));
}

function createCourseCard(course: Course): ICourseCard {
  return {
    imageUrl: !course.imgUrl ? getTempImage(course) : course.imgUrl,
    name: course.name,
    relativeUrl: createCourseLessonUrl(course.id),
    difficulty: course.difficulty || "",
    difficultyCategories: course.difficultyCategories,
    theme: course.theme,
    description: course.description,
    lessonCount: course.lessonCount,
  };
}

export function createCourseLessonUrl(courseId: number): string {
  return `/course-lessons/${courseId}`;
}

function getTempImage(_course: Course): string {
  return miscImages.genericCourse;
}